import { ActionTypes } from '@/store/actionTypes'
import {
  ContactBirthdayRegister,
  ContactsBirthdayRegisterActionTypes,
} from '@/store/contactBirthdayRegister/types'

const initialState: ContactBirthdayRegister = {
  name: '',
  birthday: new Date('1980/01/01'),
  phone_number: '',
  member_id: '',
  mail_address: '',
  charge_history_status: '',
  charge_history_date: new Date(),
  charge_history_money: '',
  transaction_history_status: '',
  transaction_history_date: new Date(),
  transaction_history_money: '',
  transaction_history_store: '',
  supay_balances_status: '',
  supay_balances: '',
  zip_code: '',
  address: '',
  require_files: [],
  other_files: [],
}

export const ContactBirthdayRegisterReducer = (
  state = initialState,
  action: ContactsBirthdayRegisterActionTypes
): ContactBirthdayRegister => {
  switch (action.type) {
    case ActionTypes.contactBirthdayRegister:
      return {
        ...state,
        name: action.payload.name,
        birthday: action.payload.birthday,
        phone_number: action.payload.phone_number,
        member_id: action.payload.member_id,
        mail_address: action.payload.mail_address,
        charge_history_status: action.payload.charge_history_status,
        charge_history_date: action.payload.charge_history_date,
        charge_history_money: action.payload.charge_history_money,
        transaction_history_status: action.payload.transaction_history_status,
        transaction_history_date: action.payload.transaction_history_date,
        transaction_history_money: action.payload.transaction_history_money,
        transaction_history_store: action.payload.transaction_history_store,
        supay_balances_status: action.payload.supay_balances_status,
        supay_balances: action.payload.supay_balances,
        zip_code: action.payload.zip_code,
        address: action.payload.address,
        require_files: action.payload.require_files,
        other_files: action.payload.other_files,
      }
    case ActionTypes.clearState:
      return initialState
    default:
      return state
  }
}
